import React, { useEffect, useState } from "react"
import ReactPaginate from "react-paginate"
import {
  Box,
  Text,
  Grid,
  Heading,
  Flex,
  Link,
  Container,
  Select,
} from "@theme-ui/components"
import { i18nContext } from "../../context/i18nContext"
import { getColor } from "@theme-ui/color"
import themeUiTheme from "../../gatsby-plugin-theme-ui"
import { ArrowUpRight } from "react-feather"

const WebinarCollection = ({ title, webinars }) => {
  const [forcePage, setForcePage] = useState(0)
  const [filteredDocuments, setFilteredDocuments] = useState(webinars)
  const documentPerPage = 8
  const pageCount = Math.ceil(filteredDocuments.length / documentPerPage)
  const categorizedDocuments = [
    ...new Set(webinars.filter(a => (a.category ? a.category.name : null))),
  ]
  const categories = [
    ...new Set(categorizedDocuments.map(a => a.category.name)),
  ]

  const [selectedPage, setSelectedPage] = useState(0)
  const [selectedDocuments, setSelectedDocuments] = useState(
    filteredDocuments.slice(
      selectedPage * documentPerPage,
      selectedPage * documentPerPage + documentPerPage
    )
  )

  useEffect(() => {
    setSelectedDocuments(
      filteredDocuments.slice(
        selectedPage * documentPerPage,
        selectedPage * documentPerPage + documentPerPage
      )
    )
  }, [filteredDocuments, selectedPage])

  function handleChange(data) {
    setSelectedPage(data.selected)
  }

  function handleSelectChange(category) {
    setForcePage(0)
    setSelectedPage(0)
    if (category !== "all") {
      setFilteredDocuments(
        webinars.filter(obj => {
          return obj.category.name === category
        })
      )
    } else {
      setFilteredDocuments(webinars)
    }
  }

  return (
    <i18nContext.Consumer>
      {t => (
        <Box>
          <Container>
            <Grid columns={[1, 1, "3fr 1fr"]} gap={[0, 0, 64]}>
              {/* <Box></Box> */}
              <Heading dir="invalid" as="h2" variant="h2" color="dark">
                {title}
              </Heading>
              {categories.length > 1 && (
                <Flex
                  sx={{ alignItems: "center", "& > div": { flex: "0 0 100%" } }}
                >
                  <Select
                    sx={{ p: 3, borderColor: "darkBackground" }}
                    onChange={e => handleSelectChange(e.target.value)}
                    defaultValue="all"
                  >
                    <option value="all">{t.allCategories}</option>
                    {categories.map(category => (
                      <option value={category}>{category}</option>
                    ))}
                  </Select>
                </Flex>
              )}
            </Grid>
          </Container>
          <Box
            sx={{
              ".pagination": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                listStyle: "none",
                li: {
                  cursor: "pointer",
                  mx: 3,
                  "&.active": {
                    a: {
                      fontWeight: "bold",
                    },
                  },
                  "a:hover": {
                    color: "dark",
                  },
                },
              },
            }}
          >
            {selectedDocuments.map(document => (
              <Flex
                sx={{
                  alignItems: "center",
                  borderTop: "1px solid",
                  borderColor: "lightGrey",
                  "&:last-child": {
                    borderBottom: "1px solid",
                    borderColor: "lightGrey",
                  },
                }}
              >
                <Container sx={{ paddingY: [4, 5] }}>
                  <Flex
                    sx={{
                      flexDirection: ["column", "column", "row"],
                      justifyContent: ["space-between"],
                      alignItems: ["flex-start", "flex-start", "center"],
                    }}
                  >
                    <Box
                      sx={{
                        marginBottom: [3, 3, 0],
                        maxWidth: ["100%", "100%", "70%"],
                      }}
                    >
                      {document.category && (
                        <Text
                          as="p"
                          sx={{
                            color: "primary",
                            mb: 2,
                            textTransform: "uppercase",
                            fontSize: 0,
                          }}
                        >
                          {document.category.name}
                        </Text>
                      )}
                      <Text
                        as="p"
                        variant="h6"
                        sx={{
                          marginTop: [0],
                          marginBottom: [0],
                          lineHeight: 1.3,
                        }}
                      >
                        {document.title}
                      </Text>
                      <Text
                        as="p"
                        variant="caption"
                        color="darkBackground"
                        mt={2}
                      >
                        {document.date} - {document.country} -{" "}
                        {document.language}
                      </Text>
                    </Box>
                    <Box
                      sx={{
                        "*": { mr: 4, "&:last-child": { mr: 0 } },
                      }}
                    >
                      <Flex
                        sx={{
                          alignItems: "center",
                          fontSize: 2,
                        }}
                      >
                        <Flex
                          sx={{
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "full",
                            width: "50px",
                            height: "50px",
                            minWidth: "50px",
                            minHeight: "50px",
                            mr: 3,
                            backgroundColor: "primary",
                          }}
                        >
                          <ArrowUpRight
                            color={getColor(themeUiTheme, "light")}
                          />
                        </Flex>
                        <Link
                          href={document.url}
                          target="blank"
                          rel="noopener nofollow"
                        >
                          {t.join}
                        </Link>
                      </Flex>
                    </Box>
                  </Flex>
                </Container>
              </Flex>
            ))}
            {pageCount > 1 && (
              <Box sx={{ mb: 6 }}>
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handleChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={forcePage}
                />
              </Box>
            )}
          </Box>
        </Box>
      )}
    </i18nContext.Consumer>
  )
}

export default WebinarCollection
